var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-create-record-form" },
    [
      _c(
        "a-form",
        { attrs: { form: _vm.form }, on: { submit: _vm.handleSubmit } },
        [
          _vm._l(_vm.rows, function (row, index) {
            return _c(
              "div",
              { key: index, staticClass: "form-row" },
              _vm._l(row, function (field) {
                return _vm.isValidField(field._id)
                  ? _c(
                      "div",
                      { key: field._id, staticClass: "form-col" },
                      [
                        _c(
                          "a-form-item",
                          { attrs: { label: field.name } },
                          [
                            field.fieldType === "text" ||
                            field.fieldType === "long-text"
                              ? _c("a-input", {
                                  model: {
                                    value: _vm.record[field._id],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.record, field._id, $$v)
                                    },
                                    expression: "record[field._id]",
                                  },
                                })
                              : field.fieldType === "number"
                              ? _c("a-input-number", {
                                  model: {
                                    value: _vm.record[field._id],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.record, field._id, $$v)
                                    },
                                    expression: "record[field._id]",
                                  },
                                })
                              : field.fieldType === "currency"
                              ? _c("a-input", {
                                  model: {
                                    value: _vm.record[field._id],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.record, field._id, $$v)
                                    },
                                    expression: "record[field._id]",
                                  },
                                })
                              : field.fieldType === "datetime"
                              ? _c("a-date-picker", {
                                  attrs: { "show-time": _vm.defaultTime },
                                  model: {
                                    value: _vm.record[field._id],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.record, field._id, $$v)
                                    },
                                    expression: "record[field._id]",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            field.fieldType === "dropdown"
                              ? [
                                  !_vm.isDynamicDropdown(field)
                                    ? _c(
                                        "a-select",
                                        {
                                          attrs: {
                                            mode: field.options.dropdown
                                              .multiple
                                              ? "multiple"
                                              : "default",
                                          },
                                          model: {
                                            value: _vm.record[field._id],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.record,
                                                field._id,
                                                $$v
                                              )
                                            },
                                            expression: "record[field._id]",
                                          },
                                        },
                                        _vm._l(
                                          field.options.dropdown.options,
                                          function (option) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: option.value,
                                                attrs: { value: option.value },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(option.value) +
                                                    "\n                            "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    : _c(
                                        "a-select",
                                        {
                                          attrs: {
                                            mode: field.options.dropdown
                                              .multiple
                                              ? "multiple"
                                              : "default",
                                            filterOption: false,
                                            showSearch: true,
                                            loading:
                                              _vm.loadingFields[field._id],
                                          },
                                          on: {
                                            search: function (value) {
                                              return _vm.handleDynamicSearch(
                                                value,
                                                field
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.record[field._id],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.record,
                                                field._id,
                                                $$v
                                              )
                                            },
                                            expression: "record[field._id]",
                                          },
                                        },
                                        _vm._l(
                                          _vm.dynamicOptions[field._id] || [],
                                          function (option) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: option.value,
                                                attrs: { value: option.value },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(option.value) +
                                                    "\n                            "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                ]
                              : field.fieldType === "checkbox"
                              ? _c("a-checkbox", {
                                  model: {
                                    value: _vm.record[field._id],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.record, field._id, $$v)
                                    },
                                    expression: "record[field._id]",
                                  },
                                })
                              : field.fieldType === "url"
                              ? _c("a-input", {
                                  model: {
                                    value: _vm.record[field._id],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.record, field._id, $$v)
                                    },
                                    expression: "record[field._id]",
                                  },
                                })
                              : field.fieldType === "email"
                              ? _c("a-input", {
                                  model: {
                                    value: _vm.record[field._id],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.record, field._id, $$v)
                                    },
                                    expression: "record[field._id]",
                                  },
                                })
                              : field.fieldType === "phone"
                              ? _c("a-input", {
                                  model: {
                                    value: _vm.record[field._id],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.record, field._id, $$v)
                                    },
                                    expression: "record[field._id]",
                                  },
                                })
                              : field.fieldType === "conversation"
                              ? _c("a-input", {
                                  model: {
                                    value: _vm.record[field._id],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.record, field._id, $$v)
                                    },
                                    expression: "record[field._id]",
                                  },
                                })
                              : field.fieldType === "json"
                              ? _c("json-cell", {
                                  attrs: {
                                    record: { data: _vm.record },
                                    field: field,
                                    outlined: true,
                                  },
                                  on: { "update-record": _vm.handleJsonUpdate },
                                })
                              : field.fieldType === "user"
                              ? _c("custom-picker", {
                                  attrs: {
                                    items: _vm.getAgentsOptions(),
                                    "label-key": "label",
                                    "id-key": "id",
                                    title: _vm.$t("message.selectAgent"),
                                    icon: "support_agent",
                                  },
                                  model: {
                                    value: _vm.record[field._id],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.record, field._id, $$v)
                                    },
                                    expression: "record[field._id]",
                                  },
                                })
                              : ["file", "image", "video", "audio"].includes(
                                  field.fieldType
                                )
                              ? _c(
                                  "div",
                                  { staticClass: "asset-upload" },
                                  [
                                    _vm.record[field._id]
                                      ? _c(
                                          "div",
                                          { staticClass: "asset-preview" },
                                          [
                                            field.fieldType === "image"
                                              ? _c("img", {
                                                  attrs: {
                                                    src: _vm.getAssetUrl(
                                                      _vm.record[field._id]
                                                    ),
                                                    alt: "Resim Önizleme",
                                                  },
                                                })
                                              : field.fieldType === "video"
                                              ? _c("video", {
                                                  attrs: {
                                                    src: _vm.getAssetUrl(
                                                      _vm.record[field._id]
                                                    ),
                                                    controls: "",
                                                  },
                                                })
                                              : field.fieldType === "audio"
                                              ? _c("audio", {
                                                  attrs: {
                                                    src: _vm.getAssetUrl(
                                                      _vm.record[field._id]
                                                    ),
                                                    controls: "",
                                                  },
                                                })
                                              : _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getAssetName(
                                                        _vm.record[field._id]
                                                      )
                                                    )
                                                  ),
                                                ]),
                                          ]
                                        )
                                      : _c(
                                          "a-upload",
                                          {
                                            attrs: {
                                              "before-upload": function (file) {
                                                return _vm.beforeUpload(
                                                  file,
                                                  field._id
                                                )
                                              },
                                              "custom-request": function (
                                                args
                                              ) {
                                                return _vm.uploadFile(
                                                  args,
                                                  field._id
                                                )
                                              },
                                              "show-upload-list": false,
                                              accept: _vm.getAcceptedFileTypes(
                                                field.fieldType
                                              ),
                                            },
                                          },
                                          [
                                            _c(
                                              "a-button",
                                              [
                                                _c("a-icon", {
                                                  attrs: { type: "upload" },
                                                }),
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(
                                                      _vm.getUploadButtonText(
                                                        field.fieldType
                                                      )
                                                    ) +
                                                    "\n                            "
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                  ],
                                  1
                                )
                              : field.fieldType === "color"
                              ? _c("color-picker", {
                                  model: {
                                    value: _vm.record[field._id],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.record, field._id, $$v)
                                    },
                                    expression: "record[field._id]",
                                  },
                                })
                              : field.fieldType === "contact"
                              ? _c("div", { staticClass: "contact-field" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "contact-wrapper",
                                      on: {
                                        mouseenter: function ($event) {
                                          _vm.activeContactField = field._id
                                        },
                                        mouseleave: _vm.handleContactMouseLeave,
                                      },
                                    },
                                    [
                                      _vm.record[field._id]
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "contact-info",
                                              on: {
                                                click: function ($event) {
                                                  _vm.isReadonlyField(field)
                                                    ? _vm.$_.noop
                                                    : _vm.viewContactProfile(
                                                        _vm.getContact(
                                                          field._id
                                                        )
                                                      )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "contact-avatar",
                                                },
                                                [
                                                  _c("PlatformIconViewer", {
                                                    attrs: {
                                                      platform: _vm.$_.get(
                                                        _vm.getContact(
                                                          field._id
                                                        ),
                                                        "platform"
                                                      ),
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "contact-name" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$_.get(
                                                        _vm.getContact(
                                                          field._id
                                                        ),
                                                        "fullname"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "a",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showContactPicker(
                                                    field._id
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("+ Kişi Ekle")]
                                          ),
                                      _vm._v(" "),
                                      _vm.activeContactField === field._id &&
                                      _vm.record[field._id] &&
                                      !_vm.isReadonlyField(field)
                                        ? _c(
                                            "div",
                                            { staticClass: "contact-actions" },
                                            [
                                              _c("SupsisButton", {
                                                attrs: {
                                                  icon: "edit",
                                                  xxsmall: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.showContactPicker(
                                                      field._id
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("SupsisButton", {
                                                attrs: {
                                                  icon: "delete",
                                                  xxsmall: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeContact(
                                                      field._id
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ])
                              : field.fieldType === "linked-record"
                              ? _c(
                                  "div",
                                  { staticClass: "linked-record-field" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "linked-record-wrapper",
                                        on: {
                                          mouseenter: function ($event) {
                                            _vm.activeLinkedRecordField =
                                              field._id
                                          },
                                          mouseleave:
                                            _vm.handleLinkedRecordMouseLeave,
                                        },
                                      },
                                      [
                                        _vm.record[field._id]
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "linked-record-info",
                                                on: {
                                                  click: function ($event) {
                                                    _vm.viewLinkedRecord(
                                                      field,
                                                      _vm.getLinkedRecord(
                                                        field._id
                                                      )
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "switch_access_shortcut"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "linked-record-label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getLinkedRecordLabel(
                                                          field._id
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "a",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.showRecordPicker(
                                                      field._id
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("+ Kayıt Ekle")]
                                            ),
                                        _vm._v(" "),
                                        _vm.activeLinkedRecordField ===
                                          field._id &&
                                        _vm.record[field._id] &&
                                        !_vm.isReadonlyField(field)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "linked-record-actions",
                                              },
                                              [
                                                _c("SupsisButton", {
                                                  attrs: {
                                                    icon: "edit",
                                                    xxsmall: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showRecordPicker(
                                                        field._id
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("SupsisButton", {
                                                  attrs: {
                                                    icon: "delete",
                                                    xxsmall: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeLinkedRecord(
                                                        field._id
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              : field.fieldType === "task"
                              ? _c("div", { staticClass: "task-field" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "task-wrapper",
                                      on: {
                                        mouseenter: function ($event) {
                                          _vm.activeTaskField = field._id
                                        },
                                        mouseleave: _vm.handleTaskMouseLeave,
                                      },
                                    },
                                    [
                                      _vm.record[field._id]
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "task-info",
                                              on: {
                                                click: function ($event) {
                                                  _vm.viewTask(
                                                    _vm.getTask(field._id)
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("FieldIcon", {
                                                staticClass: "task-icon",
                                                attrs: {
                                                  type: "task",
                                                  size: 16,
                                                  "default-icon": field.icon,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "task-title" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$_.get(
                                                        _vm.getTask(field._id),
                                                        "title"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "a",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showTaskPicker(
                                                    field._id
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("+ Task Ekle")]
                                          ),
                                      _vm._v(" "),
                                      _vm.activeTaskField === field._id &&
                                      _vm.record[field._id] &&
                                      !_vm.isReadonlyField(field)
                                        ? _c(
                                            "div",
                                            { staticClass: "task-actions" },
                                            [
                                              _c("SupsisButton", {
                                                attrs: {
                                                  icon: "edit",
                                                  xxsmall: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.showTaskPicker(
                                                      field._id
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("SupsisButton", {
                                                attrs: {
                                                  icon: "delete",
                                                  xxsmall: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeTask(
                                                      field._id
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e()
              }),
              0
            )
          }),
          _vm._v(" "),
          _c(
            "a-form-item",
            [
              _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    "html-type": "submit",
                    loading: _vm.loading,
                  },
                },
                [_vm._v("Kaydet")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.showContactModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Kişi Seç",
                okText: "Kaydet",
                xlarge: "",
                className: "contact-picker-modal keydown-prevent-modal",
              },
              on: { cancel: _vm.closeContactModal },
            },
            [
              _c("List", {
                attrs: { "picker-mode": "" },
                on: { select: _vm.onContactSelected },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showRecordPickerModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Kayıt Seç",
                okText: "Kaydet",
                xlarge: "",
                className: "record-picker-modal keydown-prevent-modal",
              },
              on: { cancel: _vm.closeRecordPickerModal },
            },
            [
              _c("RecordPicker", {
                attrs: {
                  "table-id": _vm.activeLinkedRecordTableId,
                  pickerMode: true,
                  labelFieldId: _vm.activeLinkedRecordLabelField,
                },
                on: { "record-selected": _vm.onRecordSelected },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showTaskPickerModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Task Seç",
                okText: "Kaydet",
                xlarge: "",
                className: "task-picker-modal keydown-prevent-modal",
              },
              on: { cancel: _vm.closeTaskPickerModal },
            },
            [
              _c("TaskListView", {
                attrs: { "picker-mode": "" },
                on: { selected: _vm.onTaskSelected },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }